import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { IdentityUserAri } from '@atlassian/ari/identity/user';
import { JiraNavigationSettingsAri } from '@atlassian/ari/jira/navigation-settings';
import type { RoadmapsContentViewQueryEntrypointProps } from './RoadmapsContentViewQueryEntrypointProps.entrypoint.types.tsx';
import type { RoadmapsContentViewQuery } from './__generated__/RoadmapsContentViewQuery.graphql.ts';
import parameters from './__generated__/RoadmapsContentViewQuery$parameters';

type Queries = { queryRef: RoadmapsContentViewQuery };

type Nav4RoadmapsContentEntryPointComponent = EntryPointComponent<
	Queries,
	{},
	RoadmapsContentViewQueryEntrypointProps,
	{}
>;

type RoadmapsEntryPointParams = EntryPointRouteParams & { currentURL?: string };

export const nav4RoadmapsContentEntryPoint: EntryPoint<
	Nav4RoadmapsContentEntryPointComponent,
	RoadmapsEntryPointParams
> = createEntryPoint({
	root: JSResourceForUserVisible<Nav4RoadmapsContentEntryPointComponent>(
		/* webpackChunkName: "nav4-roadmaps-content-entry-point" */ './RoadmapsContentViewQuery.tsx',
		{
			includeInShellOnlySsrBundle: true,
			entryFsSsrLiftImportToModule: true,
		},
	),

	getPreloadProps: (params: RoadmapsEntryPointParams) => {
		const cloudId = params.tenantContext?.cloudId || '';
		const activationId = params.tenantContext?.activationId || '';

		// FG fg('navx-3660-fix-l2-l3-aris') seems to break ordering so it would be skipped for now
		const entityAri = JiraNavigationSettingsAri.create({
			siteId: cloudId,
			activationId,
			navigationSettingScope: 'collections',
		}).toString();

		const variables = {
			cloudId,
			currentURL: params.currentURL,
			entityAri,
			ownerAri: IdentityUserAri.create({
				userId: params.tenantContext.atlassianAccountId || 'UNKNOWN',
			}).toString(),
			skipOrderQuery: false,
		};
		return {
			queries: {
				queryRef: {
					parameters,
					variables,
				},
			},
		};
	},
});
